import api from './api';

export interface ExtraProduct {
    id: string;
    title: string;
    description: string;
    imageUrl: string;
    price: number;
    status: 'active' | 'inactive';
    createdAt: Date;
    updatedAt: Date;
}

export interface CreateExtraProductData {
    title: string;
    description?: string;
    imageUrl?: string;
    price: number;
    status?: 'active' | 'inactive';
}

export interface UpdateExtraProductData extends Partial<CreateExtraProductData> { }

export const extraProductsApi = {
    // Public - Get active extra products
    async getActiveExtraProducts(): Promise<ExtraProduct[]> {
        try {
            const response = await api.get('/admin/extra-products/list');
            return response.data;
        } catch (error: any) {
            console.error('Error fetching extra products:', error);
            throw new Error(error.response?.data?.error || 'Extra ürünler yüklenemedi');
        }
    },

    // Admin - Get all extra products
    async getAllExtraProducts(): Promise<{ extraProducts: ExtraProduct[]; total: number }> {
        try {
            const response = await api.get('/admin/extra-products');
            return response.data;
        } catch (error: any) {
            console.error('Error fetching all extra products:', error);
            throw new Error(error.response?.data?.error || 'Extra ürünler yüklenemedi');
        }
    },

    // Admin - Get single extra product
    async getExtraProduct(id: string): Promise<ExtraProduct> {
        try {
            const response = await api.get(`/admin/extra-products/${id}`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching extra product:', error);
            throw new Error(error.response?.data?.error || 'Extra ürün yüklenemedi');
        }
    },

    // Admin - Create extra product
    async createExtraProduct(data: CreateExtraProductData): Promise<ExtraProduct> {
        try {
            const response = await api.post('/admin/extra-products', data);
            return response.data;
        } catch (error: any) {
            console.error('Error creating extra product:', error);
            throw new Error(error.response?.data?.error || 'Extra ürün oluşturulamadı');
        }
    },

    // Admin - Update extra product
    async updateExtraProduct(id: string, data: UpdateExtraProductData): Promise<ExtraProduct> {
        try {
            const response = await api.put(`/admin/extra-products/${id}`, data);
            return response.data;
        } catch (error: any) {
            console.error('Error updating extra product:', error);
            throw new Error(error.response?.data?.error || 'Extra ürün güncellenemedi');
        }
    },

    // Admin - Delete extra product
    async deleteExtraProduct(id: string): Promise<{ success: boolean }> {
        try {
            const response = await api.delete(`/admin/extra-products/${id}`);
            return response.data;
        } catch (error: any) {
            console.error('Error deleting extra product:', error);
            throw new Error(error.response?.data?.error || 'Extra ürün silinemedi');
        }
    },

    // Admin - Update status
    async updateExtraProductStatus(
        id: string,
        status: 'active' | 'inactive'
    ): Promise<ExtraProduct> {
        try {
            const response = await api.put(`/admin/extra-products/${id}/status`, { status });
            return response.data;
        } catch (error: any) {
            console.error('Error updating extra product status:', error);
            throw new Error(error.response?.data?.error || 'Durum güncellenemedi');
        }
    },
};
